import { useQuery } from "@tanstack/solid-query";
import { type Accessor, createMemo } from "solid-js";
import { createJobOfferQueryOptions } from "@/domains/job-offer/api";
import { PaymentType } from "@/domains/job-offer/create/constants";
import { useFreelanceSearchStore } from "../store/freelance-search-store";

/**
 * True only when the active-search session is linked to a fixed-budget job offer.
 * Degrades to `false` while the offer detail is loading or when standalone / hourly.
 */
export const useIsFixedOfferContext = (): Accessor<boolean> => {
  const [storeState] = useFreelanceSearchStore();

  const query = useQuery(() =>
    createJobOfferQueryOptions(storeState.jobOfferId ?? ""),
  );

  return createMemo(() => {
    if (storeState.researchType !== "from_offer") return false;
    if (!storeState.jobOfferId) return false;
    return query.data?.job_offer?.payment_type === PaymentType.FIXED;
  });
};
